export default "__VITE_ASSET__Dpnpnb7g__"